import './style.scss';
import '../../universal-notice/v1/scripts';
import { scrollTo } from "../../../js/components/scrollToWithCallback";

const pushAnalytics = (link) => {
  const label = link.dataset.analytics;

  if (label) {
    window.$analytics && window.$analytics.push('header-link-click', { label });
  }
}

const scrollHandler = (link) => {
  const selector = link.getAttribute('href');
  const elementScroll = selector && document.querySelector(selector);

  if (!elementScroll) {
    return;
  }

  const namedElement = elementScroll.closest('[data-block-name]');

  window.programlyScrollingTo = (namedElement && namedElement.dataset.blockName) || 'not-named-block';
  scrollTo(elementScroll, () => window.programlyScrollingTo = null);

  pushAnalytics(link);
}

export default !async function () {
  const header = document.querySelector('.header');

  if (!header) {
    return;
  }

  const mobileMenuTemplate = header.querySelector('#header-mobile-menu')
  const mobileMenuButton = header.querySelector('.header__nav-btn');
  let HeaderMobileMenu = null;

  if (mobileMenuTemplate) {
    try {
      ({ HeaderMobileMenu } = await import('../../../js/components/HeaderMobileMenu/scripts'));
    } catch (error) {
      window.Sentry?.captureException('[HeaderMobileMenu]: Failed to load module', error);

      if (mobileMenuButton) {
        mobileMenuButton.setAttribute('hidden', 'hidden');
        mobileMenuButton.setAttribute('aria-hidden', 'true');
      }
    }
  }

  header.addEventListener('click', (evt) => {
    if (evt.target.closest('.header__nav-btn') && HeaderMobileMenu && mobileMenuTemplate) {
      new HeaderMobileMenu(mobileMenuTemplate, { blockName: 'header' }).init();

      window.$analytics?.push('header-burger-click', {
        label: 'Opened'
      });

      return;
    }

    const closestLink = evt.target.closest('.header__nav-link');

    if (closestLink) {
      if (closestLink.getAttribute('href')?.startsWith('#')) {
        evt.preventDefault();
      }

      scrollHandler(closestLink);
    }
  })

  // Fixed header
  const SCROLL_GAP = 28;

  let scrollPos = 0;
  let isHiding = false;
  let directionChangeY = 0;
  let prevScrollRevert = false;

  const setStickyHeader = () => {
    const headerHeight = header.offsetHeight;
    const isScrollRevert = scrollY < scrollPos;

    if (isScrollRevert !== prevScrollRevert) {
      directionChangeY = scrollY;
      prevScrollRevert = isScrollRevert;
    }

    if (Math.abs(scrollY - directionChangeY) < SCROLL_GAP) {
      scrollPos = scrollY;
      return;
    }

    if (isScrollRevert && scrollY > (headerHeight * 2) && !header.classList.contains('header--sticky')) {
      requestAnimationFrame(() => {
        header.style.animation = '400ms ease-in-out showHeader';
        header.classList.add('header--sticky');
      })
    } else if (!isScrollRevert && scrollY > headerHeight && header.classList.contains('header--sticky') && !isHiding) {
      isHiding = true;
      header.style.animation = '400ms ease-in-out hideHeader';

      const onHideEnd = () => {
        header.removeEventListener('animationend', onHideEnd);
        header.classList.remove('header--sticky');
        header.style.animation = '';
        isHiding = false;
      };

      header.addEventListener('animationend', onHideEnd);
      setTimeout(onHideEnd, 400);
    }

    scrollPos = scrollY;
  };

  document.addEventListener('scroll', setStickyHeader);
}();
